export function datedFilename(prefix: string) {
  return `${prefix}-${new Date().toISOString().slice(0, 10)}.json`
}

export async function saveJsonFile(data: unknown, filename: string) {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' })
  const file = new File([blob], filename, { type: 'application/json' })
  try {
    if (navigator.canShare?.({ files: [file] })) {
      await navigator.share({ files: [file], title: filename })
      return 'shared' as const
    }
  } catch (error) {
    if ((error as DOMException).name === 'AbortError') return 'cancelled' as const
  }
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
  URL.revokeObjectURL(url)
  return 'downloaded' as const
}
